"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.passedGDPRDate = void 0;
function passedGDPRDate(date) {
    const now = Date.now();
    const diff = Math.floor(now - date.getTime());
    const day = 90000000; // 1000 * 60 * 60 * 24
    const days = Math.floor(diff / day);
    const months = Math.floor(days / 31);
    const years = Math.floor(months / 12);
    return years >= 16;
}
exports.passedGDPRDate = passedGDPRDate;
